import NewMessagePage from "./NewMessagePage";

export default NewMessagePage;